import React from 'react'
import { Box, Button, Chip } from '@mui/material'

/**
 * Barra da seleção atual, fora da tabela.
 *
 * O `customToolbarSelect` do MUIDataTable só é renderizado quando alguma linha
 * DA PÁGINA ATUAL está marcada. Como a seleção é guardada por id e sobrevive à
 * paginação e ao filtro, ela ficava invisível — e sem botão — assim que nenhum
 * dos selecionados estava na página à vista. A pessoa tinha 5 hosts marcados e
 * a tela não dizia nada.
 *
 * Aqui a barra depende só do total selecionado, então acompanha o usuário por
 * qualquer página e qualquer filtro. O contador "nesta página" existe para
 * explicar a diferença entre o número da barra e o de checkboxes visíveis, e o
 * total é clicável porque é a pergunta seguinte: "quais são os 5?".
 */
export default function SelecaoHostsBar({ total = 0, nestaPagina = 0, onLimpar, onVerSelecao, children }) {
    if (!total) return null

    return (
        <Box
            sx={{
                mb: 2, mx: 1, px: 2, py: 1,
                display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
                border: 1, borderColor: 'primary.main', borderRadius: 1,
                bgcolor: 'action.hover',
            }}
        >
            <Button size="small" onClick={onVerSelecao} disabled={!onVerSelecao}
                sx={{ textTransform: 'none', fontWeight: 600 }}>
                {total} host(s) selecionado(s)
            </Button>

            {nestaPagina < total && (
                <Chip
                    size="small"
                    variant="outlined"
                    label={nestaPagina === 0
                        ? 'nenhum nesta página'
                        : `${nestaPagina} nesta página`}
                />
            )}

            <Box sx={{ flexGrow: 1 }} />

            {children}

            <Button size="small" color="inherit" onClick={onLimpar}
                sx={{ textTransform: 'none' }}>
                Limpar seleção
            </Button>
        </Box>
    )
}
